export default "__VITE_ASSET__CSdj4MA7__"